import { ChevronLeft, ChevronRight } from 'lucide-react';
import type { CostChartViewMode } from '../../costs/costChartTypes';

type LacCrawlJobTimeSeriesChartHeaderProps = {
  title: string;
  navLabel: string;
  previousLabel: string;
  nextLabel: string;
  viewToggleLabel: string;
  dailyLabel: string;
  monthlyLabel: string;
  rangeLabel: string;
  canGoNext: boolean;
  mode: CostChartViewMode;
  onModeChange: (mode: CostChartViewMode) => void;
  onPrev: () => void;
  onNext: () => void;
};

export function LacCrawlJobTimeSeriesChartHeader({
  title,
  navLabel,
  previousLabel,
  nextLabel,
  viewToggleLabel,
  dailyLabel,
  monthlyLabel,
  rangeLabel,
  canGoNext,
  mode,
  onModeChange,
  onPrev,
  onNext,
}: LacCrawlJobTimeSeriesChartHeaderProps) {
  return (
    <div className="cost-chart__header">
      <h2 className="cost-chart__title">{title}</h2>
      <nav className="cost-chart__nav" aria-label={navLabel}>
        <button
          type="button"
          className="cost-chart__nav-btn"
          onClick={onPrev}
          aria-label={previousLabel}
        >
          <ChevronLeft size={16} />
        </button>
        <span className="cost-chart__nav-label">{rangeLabel}</span>
        <button
          type="button"
          className="cost-chart__nav-btn"
          onClick={onNext}
          disabled={!canGoNext}
          aria-label={nextLabel}
        >
          <ChevronRight size={16} />
        </button>
      </nav>
      <div className="cost-chart__controls">
        <div
          className="cost-chart__toggle"
          role="group"
          aria-label={viewToggleLabel}
        >
          <button
            type="button"
            className={[
              'cost-chart__toggle-btn',
              mode === 'daily' && 'cost-chart__toggle-btn--active',
            ]
              .filter(Boolean)
              .join(' ')}
            onClick={() => onModeChange('daily')}
            aria-pressed={mode === 'daily'}
          >
            {dailyLabel}
          </button>
          <button
            type="button"
            className={[
              'cost-chart__toggle-btn',
              mode === 'monthly' && 'cost-chart__toggle-btn--active',
            ]
              .filter(Boolean)
              .join(' ')}
            onClick={() => onModeChange('monthly')}
            aria-pressed={mode === 'monthly'}
          >
            {monthlyLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
